<template>
    <div class="register register-wrapper mt-0 pb-0">
        <div class="content">

        <div class="text-red subtitle mb-3 text-center" v-if="!$isMobile">{{ $t('register_page_title') }}</div>

        <form @submit.prevent="register" @keydown="form.errors[$event.target.name] = null">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="register-base">
                        <img src="/assets/frontend/register_base.svg" alt="" />
                        <div class="register-inputs">
                            <input type="text" class="form-control" placeholder="* E-post" name="email" v-model="form.email" />
                            <div v-if="form.errors.email" class="invalid-feedback d-block text-left" v-html="form.errors.email"></div>

                            <div class="city-wrapper mt-3">
                                <div class="bg-white" style="color: #000">
                                    <multiselect
                                        placeholder="* Stad"
                                        value-prop="id"
                                        track-by="name"
                                        label="name"
                                        name="city_id"
                                        :searchable="true"
                                        v-model="form.city_id"
                                        :options="$page.props.cities"
                                        :class="{ 'is-invalid': form.errors.city_id }"
                                        @input="form.errors.city_id = null"/>
                                </div>
                                <div v-if="form.errors.city_id" class="invalid-feedback d-block text-left">
                                    {{ form.errors.city_id }}
                                </div>
                            </div>

                            <input type="password" name="password" class="form-control" placeholder="* Lösenord (minst 8 tecken)" v-model="form.password" :class="{ 'is-invalid': form.errors.password }"/>
                            <div v-if="form.errors.password" class="invalid-feedback d-block text-left">
                                {{ form.errors.password }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="buttons" v-bind:class="{ 'buttons-mobile': $isMobile }">
                        <button type="button" class="btn btn-danger w-100 font-weight-bold" v-if="form.processing">Laddar...</button>
                        <button type="submit" class="btn btn-danger w-100 font-weight-bold" v-else>{{ $t('register') }}</button>
                        <div class="form-check my-2">
                            <label class="form-check-label" style="line-height: 1.2;">
                                <input class="form-check-input" type="checkbox" value="option1" v-model="form.deals" />
                                Ja, tack. Jag vill prenumerera på pangrabatter och superdeals från Familjekortet.
                            </label>
                        </div>
                        <div class="text-under-sign-up-button">
                            <span> Genom att bli medlem godkänner du våra </span>
                            <inertia-link class="text-lowercase" href="/membership-terms" v-on:click.native="closeRegisterModal()">{{ $t('membership-terms') }}</inertia-link>
                            <span>och </span>
                            <inertia-link class="text-lowercase" href="/integrity-policy" v-on:click.native="closeRegisterModal()">{{ $t('integrity-policy') }}</inertia-link> .
                        </div>
                        <div class="flex">
                            <span class="float-left question">
                                Är du redan medlem?
                            </span>
                            <span style="font-size: 1rem;float: left;margin: 7px 5px;line-height: 1.2;display: inline;font-family: 'AvertaBold';color: #E05054 !important;text-decoration: underline;" class="question cursor-pointer" data-bs-toggle="modal" data-bs-target="#loginModal">{{ $t('login') }}!</span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    </div>
</template>

<script>
    export default {
        inject: ['$isMobile'],
        data() {
            return {
                form: this.$inertia.form({
                    email: null,
                    city_id: null,
                    password: null,
                    deals: true,
                }),
            }
        },
        methods: {
            register(){
                if (this.form.processing) {
                    return;
                }

                this.form.processing = true;

                setTimeout(() => {
                    this.form.post(`/api/member/register`, {
                        onSuccess: () => (
                            $('#registerModal').modal('hide') &&
                            $('#successRegistrationModal').modal('show')
                        )
                    });
                }, 300);
            },
            closeRegisterModal(){
                $("#registerModal").modal("hide");
            }
        }
    }
</script>
